import { useSignal } from '@preact/signals-react/runtime';
import { useState } from 'react';

import { UUID } from '~/utils/uuid';
import type { Message } from './types';

type UseChatMessagesProps = {
  initialChatId?: string;
};

export function useChatMessages({ initialChatId }: UseChatMessagesProps = {}) {
  const chatId = useSignal(initialChatId ?? UUID());
  const messages = useSignal<Message[]>([]);
  const [isInitial, setIsInitial] = useState(messages.value.length === 0);

  const addMessage = (message: Message) => {
    messages.value = [...messages.value, message];
    if (isInitial) setIsInitial(false);
  };

  const updateLastMessage = (updatedMessage: Partial<Message>) => {
    const updatedMessages = [...messages.value];
    if (updatedMessages.length > 0) {
      updatedMessages[updatedMessages.length - 1] = {
        ...updatedMessages[updatedMessages.length - 1],
        ...updatedMessage,
      };
      messages.value = updatedMessages;
    }
  };

  const addOrUpdateAssistantMessage = (
    content: string,
    status: Message['status'],
  ) => {
    const lastMessage = messages.value[messages.value.length - 1];

    if (
      !lastMessage ||
      lastMessage.type !== 'ai' ||
      lastMessage.status === 'finished'
    ) {
      const newMessage: Message = {
        id: UUID(),
        type: 'ai',
        content,
        status,
      };
      addMessage(newMessage);
    } else {
      updateLastMessage({
        content: lastMessage.content + content,
        status,
      });
    }
  };

  return {
    chatId,
    messages,
    isInitial,
    setIsInitial,
    addMessage,
    updateLastMessage,
    addOrUpdateAssistantMessage,
  };
}
